(function() {
    'use strict';

    angular
        .module('editorApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
